<template>
  <div>
    <li @click="onOpen">
      <p>権利表記</p>
      <img class="chev" src="@/assets/chevron.svg" />
    </li>
    <div v-show="isDialogOpen" class="background" @click="onClose"></div>
    <div v-show="isDialogOpen" class="dialog">
      <p class="title">権利表記</p>
      <p>This app uses Font Awesome Free</p>
      <p>
        <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank"
          >https://creativecommons.org/licenses/by/4.0/</a
        >
      </p>
      <p>
        <a href="https://fontawesome.com/license/free" target="_blank"
          >https://fontawesome.com/license/free</a
        >
      </p>
      <div class="button close" @click="onClose">閉じる</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "kenri-dialog",
  components: {},
  props: {},
  computed: {},
  data() {
    return {
      isDialogOpen: false,
    };
  },
  methods: {
    onOpen() {
      this.isDialogOpen = true;
    },
    onClose() {
      this.isDialogOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

li {
  margin: 0;
  display: flex;
  padding: 1rem 0.5rem;
  font-size: 0.8rem;
  border-top: 1px #e7e7e7 solid;
  position: relative;
  .chev {
    transform: rotate(-90deg);
    height: 0.5rem;
  }
  p {
    margin: 0;
    width: calc(100% - 1.5rem);
  }
}
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.dialog {
  position: fixed;
  flex-direction: column;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-55%);
  background-color: white;
  z-index: 1001;
  width: 80vw;
  overflow-y: scroll;
  padding: 1rem;
  border-radius: 12px;

  .title {
    font-size: 1.25rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 1rem;
  }
  p {
    margin: 0.5rem 0;
    text-align: center;
  }
  a {
    text-align: center;
    margin: 0.5rem 0;
    word-wrap: break-word;
    font-size: 0.8rem;
  }

  .button {
    margin: 1rem 0;
    text-align: center;
    border-radius: 4px;
    background-color: #5cd5d6;
    padding: 0.75rem 0;
    color: white;
    font-size: 1.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyPage/KenriDialog.vue